import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CountriesApp from './App';

ReactDOM.render(
  <CountriesApp />,
  document.getElementById('root')
);
